"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchDisplaysQueryDto = void 0;
const cursor_pagination_1 = require("../../cursor-pagination");
class SearchDisplaysQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    bounds;
    categories;
    createdAtFrom;
    createdAtTo;
    displayIds;
    exclusions;
    exclusionsMode;
    flatten;
    from;
    isArchived;
    isConnected;
    lastConnectionDateFrom;
    lastConnectionDateTo;
    locations;
    mediaTypes;
    minApproximateDailyImpressions;
    maxApproximateDailyImpressions;
    orientation;
    owners;
    platformProviders;
    providers;
    search;
    tags;
    timetable;
    to;
    viewConnected;
    viewExternal;
    viewHide;
    viewMyDisplays;
    viewPrivate;
    nearbyServices;
    geoLocation;
    price;
    budget;
    scoring;
    groupIds;
    distinct; // distinct by groupId, so only one display per group is returned
}
exports.SearchDisplaysQueryDto = SearchDisplaysQueryDto;
